import { TRecommendation } from '../../types/recommendation';

export function getCallData(offer: TRecommendation) {
  const {
    phoneNumbers: [phone] = [],
    gaLabel,
    agentAvailability,
    calltracking,
    isCalltrackingEnabled,
    author,
    isDeveloper,
  } = offer;
  const { isFromLeadFactory, id: authorUserId } = author || {};

  const phoneString = phone
    ? `${phone.countryCode && phone.countryCode.startsWith('+') ? '' : '+'}${phone.countryCode}${phone.number}`
    : null;

  return {
    phone: phoneString,
    gaLabel,
    siteBlockId: calltracking?.comagicId || null,
    isCalltrackingEnabled,
    isLeadFactory: isFromLeadFactory,
    isDeveloper,
    agentAvailability,
    authorUserId,
  };
}
